import { ComponentBase, component } from "@sygnal/sse-core";

@component('primary-btn')
export class PrimaryBtnComponent extends ComponentBase {

  protected async onLoad(): Promise<void> {
    this.injectShineStyles();
  }

  private injectShineStyles(): void {
    const style = document.createElement("style");
    style.textContent = [
      ".primary-btn-solid { position: relative; overflow: hidden; }",
      ".primary-btn-solid::before { content: ''; position: absolute; top: 0; left: -125%; width: 60%; height: 100%; background: rgba(255,255,255,0.4); transform: skewX(-45deg); transition: left 500ms ease-out; pointer-events: none; }",
      ".primary-btn-solid:hover::before { left: 150%; }",
    ].join(" ");
    document.head.appendChild(style);
  }
}
